/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterTopicKind = (typeof FilterTopicKind)[keyof typeof FilterTopicKind];

export const FilterTopicKind = {
  topic: 'topic',
} as const;
